
export default function GuaranteeSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto bg-gradient-to-br from-green-50 to-emerald-50 rounded-3xl p-10 lg:p-16 border-2 border-green-200 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-green-100/50 rounded-full -translate-y-1/2 translate-x-1/2"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-emerald-100/50 rounded-full translate-y-1/2 -translate-x-1/2"></div>

          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-5 gap-10 items-center">
            <div className="lg:col-span-2 flex justify-center">
              <div className="w-48 h-48 rounded-full bg-gradient-to-br from-green-500 to-emerald-600 flex items-center justify-center shadow-2xl">
                <div className="text-center">
                  <i className="ri-shield-check-fill text-white text-5xl"></i>
                  <p className="text-white text-2xl font-bold mt-1">15 dias</p>
                  <p className="text-green-100 text-xs font-medium">de garantia</p>
                </div>
              </div>
            </div>

            <div className="lg:col-span-3">
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                Garantia Incondicional de 15 Dias
              </h2>
              <p className="text-base text-gray-600 leading-relaxed mb-6">
                Se por qualquer motivo você sentir que o curso não é para você, basta enviar um e-mail dentro de 15 dias e devolvemos <strong>100% do seu investimento</strong>. Sem perguntas, sem burocracia. O risco é todo nosso.
              </p>
              <div className="flex flex-wrap gap-4">
                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-green-500 text-lg"></i>
                  Reembolso total garantido
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-green-500 text-lg"></i>
                  Sem perguntas
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-700">
                  <i className="ri-checkbox-circle-fill text-green-500 text-lg"></i>
                  Processo simples e rápido
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
